export const FIND_RESULTS_FAILURE = 'FIND_RESULTS_FAILURE';

export const findResultsFailure = ({ error, request }) => ({
    type: FIND_RESULTS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});